import React, { Component } from "react";
import { withRouter } from "react-router";
import Graph from "./Graph";
import {STAGE_SHORT, STAGE_COLOR_CODE, STAGE_ICONS } from "../../constants";
import { sendEvent } from "../../util/utils";

class Status extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasGraph: true,
    };
  }
  
  processName(name) {
    if (name.length > 17) {
      return name.substring(0, 16) + "...";
    } else {
      return name;
    }
  }

  mapObject() {
    const examStyle = {
      backgroundImage: "none",
    };

    const examTextStyle = {
      margin: "0 0 0 0",
    };

    let array = [],
      arrayLeft = [],
      arrayRight = [];

    let counter = 0;

    if (this.state.hasGraph && this.props.status) {
      Object.keys(this.props.status).forEach((index) => {
        if (STAGE_SHORT[index]) {
          if (counter % 2 == 0) {
            arrayLeft.push(
              <button
                key={index}
                value={index}
                className={`exam-status exams-status-square status-${STAGE_ICONS[index]}`}
                onClick ={
                  (e)=>{
                    this.props.filterBy(e.currentTarget.value)
                  }
                }
                onMouseOver={()=> sendEvent("highlight-stage",index)}
                onMouseOut={()=> sendEvent("reset-markers",index)}
                style={
                  (examStyle,
                  examTextStyle,
                  { backgroundColor: STAGE_COLOR_CODE[index] || STAGE_COLOR_CODE['Default'], border: 'none' })
                }
              >
                {this.processName(STAGE_SHORT[index] || "")}
                <span className="exams-qty">{this.props && this.props.status && this.props.status[index]}</span>
              </button>
            );
          } else {
            arrayRight.push(
              <button
                key={index}
                value={index}
                className={`exam-status exams-status-square status-${STAGE_ICONS[index]}`}
                onClick ={
                  (e)=>{
                    this.props.filterBy(e.currentTarget.value)
                  }
                }
                onMouseOver={()=> sendEvent("highlight-stage",index)}
                onMouseOut={()=> sendEvent("reset-markers",index)}
                style={
                  (examStyle,
                  examTextStyle,
                  { backgroundColor: STAGE_COLOR_CODE[index] || STAGE_COLOR_CODE['Default'], border: 'none' })
                }
              >
                {this.processName(STAGE_SHORT[index] || "")}
                <span className="exams-qty">{this.props.status[index]}</span>
              </button>
            );
          }

          counter++;
        }
      });
      array.push(arrayLeft);
      array.push(arrayRight);
    } else if (this.props.status) {
      Object.keys(this.props.status).forEach((index) => {
        if (index !== "TOTAL") {
          array.push(
            <div className={"col-6 col-sm-6 exam-type-cards"} key={index}>
              <button
                value={index}
                className={"exam-status-no-graph"}
                onClick ={
                  (e)=>{
                    this.props.filterBy(e.currentTarget.value)
                  }
                }
                onMouseOver={()=> sendEvent("highlight-stage",index)}
                onMouseOut={()=> sendEvent("reset-markers",index)}
                style={
                  (examStyle, { backgroundColor: STAGE_COLOR_CODE[index] || STAGE_COLOR_CODE['Default'], border: 'none' })
                }
              >
                <div className={`status-${STAGE_ICONS[index]}`}></div>
                <p style={examTextStyle}>
                  {this.processName(STAGE_SHORT[index] || "")}
                </p>
                <span className="exams-qty-no-graph">
                  {this.props.status[index]}
                </span>
              </button>
            </div>
          );
          counter++;
        }
      });
    }
    return array;
  }

  createDataArray() {
    let response = [],
      values = [],
      colors = [],
      label = [];

    let statusArray = []
    Object.keys(this.props.status).forEach((index) => {
        if(index !== 'TOTAL'){
          statusArray.push([index, this.props.status[index]])
        }
    });
    
    statusArray = statusArray.sort((a,b)=> {
      if(a[1]<b[1]){
        return -1;
      }
      if(a[1]>b[1]){
        return 1
      }
      return 0;
    })

    statusArray.forEach((element) => {
      label.push(STAGE_SHORT[element[0]])
      values.push(element[1])
      colors.push(STAGE_COLOR_CODE[element[0]]);
    });

    response.push(label);
    response.push(values);
    response.push(colors);
    return response;
  }

  render() {
    let graphData = [];
    let arrayLeft = [],
      arrayRight = [];

    if (this.state.hasGraph) {
      graphData = this.createDataArray();
      let columns = this.mapObject();
      arrayLeft = columns[0];
      arrayRight = columns[1];
    }

    return (
      <div className="exams-status-filter">
        <div className="row row-gutter-10 align-items-center" style={{maxWidth: '100%', marginLeft:'0'}}>
          {this.state.hasGraph ? (
            <>
              <div className="col-sm order-sm-2">
                <Graph graphData={graphData}></Graph>
              </div>
              <div className="col order-sm-1" style={{ flex: "1 0 27%" }}>
                {arrayLeft}
              </div>
              <div className="col order-sm-3" style={{ flex: "1 0 27%" }}>
                {arrayRight}
              </div>
            </>
          ) : (
            this.mapObject()
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(Status);
